import React, { useState, useEffect, useRef, ChangeEvent } from 'react';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
//import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ClearIcon from "@mui/icons-material/Clear";
import {
    Box,
    Button,
    TextField,
    Typography,
    CircularProgress,
    Alert,
    Stack,
    Container,
    Paper,
    InputAdornment,
    IconButton,
    FormControlLabel,
    Checkbox
} from '@mui/material';

import { useStartSmsAuthMutation, useVerifySmsCodeMutation } from '../../features/oidcSlice';
import { GetCountryTypeByLabelDefualtToUs, USCountryType } from '../../app/components/CountryCodes';
import { printError } from '../../app/utils';
import Link from "@mui/material/Link";
import { User, UserManager, UserManagerSettings } from 'oidc-client-ts';
import { useAuth } from 'react-oidc-context';

import { useCustomAuth } from '../../app/auth/useCustomAuth';
import { privacyHref, TermsOfUseHref } from '../../app/components/sharedcomponents';
import { baseName } from '../..';
import { getCleanedLocationUrl } from '../../MagicLinkGuard';
import { useNavigate } from 'react-router-dom';
import { SmsConsent } from '../profile/SmsConsent';


/** Carrier/CTIA long-code (10DLC) opt-in disclosure. Every element here is
 *  registration-relevant — brand, program, message types, frequency, rates,
 *  STOP/HELP — so change the wording only alongside the campaign registration.
 *  Terms of Use / Privacy Policy is NOT included: it is a separate required
 *  acceptance (`smsTermsOfUseAndPrivacy`), not part of the messaging consent. */
export const smsDisclosure = (action: string = "By checking this box, I consent ") => (
    <Typography variant="caption" sx={{ display: "block", lineHeight: 1.5 }}>
        {action}to receive SMS messages from Polygon Health via the Patient Connect platform at the
        phone number provided. Messages include account security alerts, secure notification links,
        and replies from Polygon Assistant when I text it. No protected health information (PHI) is
        sent via SMS. Message frequency varies. Msg &amp; data rates may apply. Reply <strong>STOP</strong>{" "}
        to opt out or <strong>HELP</strong> for help.
    </Typography>
);


export const smsSupportContact = () => (
    <Typography variant="caption" sx={{ display: "block", lineHeight: 1.5, color: 'text.secondary' }}>
        For assistance, contact:{" "}
        <Link href="mailto:support@polygonhealth.com" underline="always">
            support@polygonhealth.com
        </Link>
    </Typography>
);


/** `inline` keeps the sentence flowing after preceding inline content (e.g. the
 *  required-field asterisk) instead of starting its own line. */
export const smsTermsOfUseAndPrivacy = (action: string, inline: boolean = false) => (
    <Typography sx={{ display: inline ? "inline" : "block", lineHeight: 1.5 }} variant="caption">{action}the <Link
        href={TermsOfUseHref}
        underline="always"
        target="_blank"
        rel="noopener noreferrer"
    >
        Terms of Use
    </Link>{" "} and <Link
        href={privacyHref}
        underline="always"
        target="_blank"
        rel="noopener noreferrer"
    >
            Privacy Policy
        </Link>
        .
    </Typography>
);


export const smsDisclosureOption = (action: string) => (<>
    {/* <Typography variant="caption" sx={{display: "block", lineHeight: 1.5}}>
        {mode}to receive recurring messages from Polygon Health via the Patient
        Connect platform, which includes account alerts, one-time codes, and
        informational updates on health resources and service features. Message
        frequency varies. Msg &amp; data rates may apply.
    </Typography> */}
    <Typography variant="caption" sx={{ display: "block", lineHeight: 1.5, mb: 1 }}>
        {action}
    </Typography>

</>
);
